import { render, staticRenderFns } from "./flight-alone.vue?vue&type=template&id=5266ae9a&"
import script from "./flight-alone.vue?vue&type=script&lang=js&"
export * from "./flight-alone.vue?vue&type=script&lang=js&"
import style0 from "./flight-alone.vue?vue&type=style&index=0&id=5266ae9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports